import React, { useState } from "react";
import { Link as ScrollLink } from "react-scroll";
import { Link } from "react-router-dom";
import { FaUserCircle, FaCaretDown, FaBars } from 'react-icons/fa';
import image from '../assets/logo.png';
import '../styles/navbar.css';

export default function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    return (
        <nav className="navbar">
            <div className="navbar-container">
                {/* Left-aligned logo */}
                <div className="navbar-logo">
                    <img src={image} alt="Logo" />
                </div>
                
                {/* Mobile menu icon */}
                <div className="mobile-menu-icon" onClick={toggleMenu}>
                    <FaBars />
                </div>

                {/* Centered menu items */}
                <ul className={`navbar-menu ${menuOpen ? 'active' : ''}`}>
                    <li>
                        <ScrollLink to="home-section" smooth={true} duration={500} onClick={toggleMenu}>
                            Home
                        </ScrollLink>
                    </li>
                    <li>
                        <ScrollLink to="appoinment-section2" smooth={true} duration={500} onClick={toggleMenu}>
                            Book Appointment
                        </ScrollLink>
                    </li>
                    <li>
                        <Link to="/dashboard" onClick={toggleMenu}>Doctor Dashboard</Link>
                    </li>
                    <li>
                        <ScrollLink to="aboutus-section" smooth={true} duration={500} onClick={toggleMenu}>
                            About Us
                        </ScrollLink>
                    </li>
                    <li>
                        <ScrollLink to="services-section" smooth={true} duration={500} onClick={toggleMenu}>
                            Services
                        </ScrollLink>
                    </li>
                </ul>

                {/* Right-aligned profile icon */}
                <div className="navbar-profile">
                    <div className="profile-icon" onClick={toggleDropdown}>
                        <FaUserCircle size={30} />
                        <FaCaretDown size={20} className="dropdown-icon" />
                    </div>
                    {isDropdownOpen && (
                        <div className="dropdown-menu">
                            <ScrollLink to="profile-section" smooth={true} duration={500}>
                                Profile
                            </ScrollLink>
                            <ScrollLink to="settings-section" smooth={true} duration={500}>
                                Settings
                            </ScrollLink>
                            <Link to="/register-user">Sign up</Link>
                        </div>
                    )}
                </div>
            </div>
        </nav>
    );
}
